<template>
	<div>
		<CubePage type="myorder-view" title="产品管理" backurl="/supplier">
			<div slot="content" class="content">
				<van-tabs v-model="active" animated line-width="60px" :sticky="true" title-active-color="#55aa7f"
					color="#55aa7f" @change="onTbasChange">
					<van-tab v-if="groupData[10] != undefined" :title="'出售中(' + groupData[10]+')'" name="0">
					</van-tab>
					<van-tab v-if="groupData[10] != undefined" :title="'待审核(' + groupData[1] +')'" name="1">

					</van-tab>
					<van-tab v-if="groupData[10] != undefined" :title="'已下架(' + groupData[20] +')'" name="2">

					</van-tab>
				</van-tabs>
				<div class="nr-content">
					<van-empty v-if="OrderList.length <1" class="custom-image" description="您还没有相关的产品">
						<template #image>
							<img src="@/assets/img/empty.png" alt="">
						</template>
					</van-empty>
					<van-list v-else v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
						:immediate-check="false">
						<div class="list-box">
							<div class="list-item" v-for="(item, idx) in OrderList" :key="item.goods_id">
								<div class="item-card">
									<van-image class="card-img" radius="10" :src="item.images" />
									<div class="card-content">
										<div class="conten-title">
											<p class="t ells">{{item.goods_name}}</p>
										</div>
										<div class="conten-desc">
											<p>实际销量:{{item.sales_actual}}</p>
											<p class="desc-red">
												￥
												<span>{{item.goods_min_price}}</span>
												起
											</p>
										</div>
									</div>
								</div>
								<div class="item-btns" v-if="active==0">
									<div class="btn-item" @click="goSjcp(item)">
										<van-icon class="iconfont" name="tianxie" class-prefix="icon" />
										<span class="btn-text">编辑</span>
									</div>
									<div class="btn-item" @click="showD(item.goods_id,20)">
										<van-icon class="iconfont" name="xiajia" class-prefix="icon" />
										<span class="btn-text">下架</span>
									</div>
								</div>
								<div class="item-btns" v-else-if="active==1">
									<div class="btn-item" @click="goSjcp(item)">
										<van-icon class="iconfont" name="tianxie" class-prefix="icon" />
										<span class="btn-text">编辑</span>
									</div>
								</div>
								<div class="item-btns" v-else-if="active==2">
									<div class="btn-item" @click="goSjcp(item)">
										<van-icon class="iconfont" name="tianxie" class-prefix="icon" />
										<span class="btn-text">编辑</span>
									</div>
									<div class="btn-item" @click="showD(item.goods_id,1)">
										<van-icon name="upgrade" />
										<span class="btn-text">发布</span>
									</div>
								</div>
							</div>
						</div>
					</van-list>
				</div>

			</div>
		</CubePage>
		<van-popup v-model="qrshow" round>
			<div class="qrshow">
				<van-image :src="qrimg" />
			</div>
		</van-popup>
	</div>
</template>

<script>
	import CubePage from '../../TP/cube-page.vue'
	import * as util from '@/utils/network'
	import {
		Dialog,
		Toast
	} from 'vant';
	import router from "@/router";
	export default {
		components: {
			CubePage
		},
		data() {
			return {
				active: 0,
				loading: false,
				finished: false,
				qrimg: '',
				qrshow: false,
				isNoData: false,
				OrderList: [],
				groupData: {},
				pageIndex: 1,
				pageTotal: 0
			}
		},
		created() {
			this.get_my_order()
		},
		methods: {
			// 浏览二维码
			onShowQrCode(id) {
				let that = this;
				// that.btnloading = true 
				that.qrimg = ''
				var url = "/addons/litestore/api.store/goodsQrcode"
				util.post(url, {
						goods_id: id
					},
					function(result) {
						that.qrimg = result.data
						that.qrshow = true
					},
				);
			},
			//修改上架
			goSjcp(item) {
				console.log(item)
				let that = this;
				this.$store.commit('setsupID', item.goods_id)
				this.$router.push({
					name: 'productEdit',
					params: {
						id: JSON.stringify(item.goods_id)
					}
				})
			},
			// 下架
			showD(id, status) {
				var title = status == 20 ? "下架" : "发布";
				Dialog.confirm({
						title: title + '操作',
						message: '确认要' + title + '该商品吗？',
					})
					.then(() => {
						this.onConfirm(id, status)
					})
					.catch(() => {
						// on cancel
					});
			},
			onConfirm(id, status) {
				let that = this
				var url = "/addons/litestore/api.supplier/shelves"
				util.post(url, {
						goods_id: id,
						status: status
					},
					function(result) {
						console.log('result', result)
						Toast(result.msg);
						setTimeout(() => {
							router.go(0);
						}, 1000)
					},
				);

			},

			onTbasChange() {
				this.clearContainer()
				this.get_my_order()
			},
			// 上滑加载更多
			onLoad() {
				let that = this
				// 异步更新数据
				that.pageIndex++;
				setTimeout(() => {
					that.get_my_order();
				}, 1000)
			},
			// 获取数据
			get_my_order() {
				var url = "/addons/litestore/api.supplier/productList"
				let that = this;
				let goods_status = 1;
				if (that.active == 0) {
					goods_status = 10;
				} else if (that.active == 2) {
					goods_status = 20;
				}
				let param = {
					goods_status: goods_status,
					page: that.pageIndex
				}
				//这里直接调用网络接口
				util.post(url, param,
					function(result) {
						that.loading = false;
						that.groupData = result.group;
						//这里对状态 进行分类
						that.pageTotal = result.total
						if (that.pageTotal < 1) {
							that.isNoData = true
							return;
						}
						if (result.rows == null || result.rows.length === 0) {
							// 加载结束
							that.finished = true;
							return;
						}
						// 将新数据与老数据进行合并
						that.OrderList = that.OrderList.concat(result.rows);

						//如果列表数据条数>=总条数，不再触发滚动加载
						if (that.OrderList.length >= that.pageTotal) {
							that.finished = true;
						}
					},
				);
			},
			// 初始化数据
			clearContainer() {
				this.loading = false
				this.finished = false
				this.OrderList = []
				this.isNoData = false
				this.pageIndex = 1
				this.pageTotal = 0
			},

		}
	}
</script>
<style lang="less">
	@import url("../../../assets/css/order.css");
	@import url("../../../assets/css/listboxless.less");

	.van-tab {
		// color: #000000 !important;
	}
</style>
<style lang="less" scoped="scoped">
	.list-box {
		// height: calc(100vh - 100px);

		.list-item {
			margin-bottom: 10px;
			background-color: #FFFFFF;

			.item-card {
				display: flex;
				padding: 10px 15px;
				border-bottom: 1px solid #eaeaea;
				box-sizing: border-box;

				.card-img {
					width: 80px;
					height: 80px;
					border-radius: 10px;
				}

				.card-content {
					flex: 1;
					flex-shrink: 0;
					width: 0;
					margin-left: 15px;

					.conten-title {
						display: flex;

						.t {
							// max-width: 238px;
							font-size: 16px;
							font-weight: 600;
						}

						.tip {
							margin-left: 15px;
							text-align: center;
							width: 45px;
							height: 20px;
							line-height: 20px;
							font-size: 12px;
							color: #FFFFFF;
							background-color: #55aa7f;
							border-radius: 5px;
						}
					}

					.conten-desc {
						margin-top: 15px;
						padding: 3px 0;
						display: flex;
						justify-content: space-between;
						align-items: center;

						p {
							color: #a3a3a3;
							font-size: 12px;
						}

						.desc-red {
							color: #ff0000;

							span {
								font-size: 18px;
							}
						}
					}
				}
			}

			.item-btns {
				height: 48px;
				display: flex;
				justify-content: space-around;
				align-items: center;

				.btn-item {

					.van-icon,
					.iconfont {
						vertical-align: middle;
						font-size: 18px;
					}

					.btn-text {
						font-size: 13px;
						padding: 0 5px;
					}
				}
			}
		}
	}
</style>
